import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import ClearButtonStyles from '@stories/Components/ClearButton/ClearButton.styles';
import styled from 'styled-components';
const Container = styled.div `
  &[data-show-mobile='true'] {
    @media ${from(Device.TabletSmall)} {
      border-right: 1px solid ${brand.green};
      padding-right: 16px;
    }
  }

  @media ${from(Device.Desktop)} {
    flex: 1 1 25%;
    display: flex;
    flex-direction: column;
    border-right: 1px solid ${brand.green};
    padding-right: 16px;

    &[data-to-span='2'] {
      flex-basis: 35%;
    }
  }
`;
const DetailWrapper = styled.div `
  ${Container}[data-show-mobile='false'] & {
    display: none;

    @media ${from(Device.Desktop)} {
      display: block;
    }
  }
`;
const TitleWrapper = styled.div `
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  align-items: flex-end;
  justify-content: space-between;

  @media ${from(Device.MobileLarge)} {
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
  }

  ${ClearButtonStyles.Container} {
    ${transition('opacity')};

    &[data-visible='false'] {
      opacity: 0;
      pointer-events: none;
    }
  }
`;
const Title = styled.span `
  ${fonts.brandonGrotesque.bold};
  text-transform: uppercase;
  font-size: 16px;
  line-height: 26px;
  border-bottom: 2px solid ${brand.green};
  letter-spacing: 0.01em;
`;
const Options = styled.ul `
  display: grid;
  gap: 16px;
  margin-bottom: 16px;

  [data-to-span='2'] & {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const Option = styled.button `
  ${ButtonReset};
  ${fonts.brandonGrotesque.regular};
  ${transition('color')};

  display: grid;
  gap: 12px;
  grid-template-columns: 42px 1fr;
  align-items: center;
  font-size: 18px;
  line-height: 22px;
  color: ${brand.black};
  text-align: left;

  [data-active='true'] &,
  &:hover {
    color: ${brand.green};
  }

  &:disabled {
    color: ${brand.black};
  }
`;
const Image = styled.img ``;
const Link = styled.a `
  ${transition('border-color')};

  ${fonts.brandonGrotesque.bold};
  text-transform: uppercase;
  color: ${brand.black};
  font-size: 16px;
  line-height: 22px;
  text-decoration: none;
  border-bottom: 2px solid ${brand.green};
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: fit-content;

  > svg {
    ${transition('transform')};

    width: 10px;
    height: 5px;
  }

  @media ${from(Device.Desktop)} {
    margin-top: auto;
    text-transform: none;
    font-size: 20px;
    line-height: 29px;
  }

  &:hover,
  &:focus {
    border-color: ${brand.black};

    > svg {
      transform: translateY(2px);
    }
  }
`;
const ListReplacementImage = styled.img `
  display: block;
  width: 100%;
`;
const IconListStyles = {
    Container,
    DetailWrapper,
    Image,
    Link,
    ListReplacementImage,
    Option,
    Options,
    Title,
    TitleWrapper,
};
export default IconListStyles;
